import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class RolesService {
  constructor(private authService: AuthService) { }

  getRolesMask() {
    this.authService.ensureCurrentUserLoaded().subscribe((response) => {
      if (response) {
        console.log('roles mask:', response);
        console.log(response.roles_mask);
      }
    });
  }

  hasAccess(roleAccess: number): Observable<any> {
    return this.authService.ensureCurrentUserLoaded().pipe(
      map((response) => {
        const roles_mask = response?.roles_mask ?? 0;
        return (roles_mask & roleAccess) !== 0;
      })
    );
  }

}
